export const PERMS = {
    READ: 'vehicle_positions.read',
    DELETE: 'vehicle_positions.delete',
}
